<template>
  <Modal>
    <Modal.Title>Dacr Timestamps</Modal.Title>
    <Modal.Body>
      <RegistrationsBody :file="file" />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" @click="close()">Close</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'
import type { File } from '@/shared/graphql/router/graphql'
import RegistrationsBody from './RegistrationsBody.vue'

defineProps<{
  file: File
}>()

const { close } = useModal()
</script>
